import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Pages/css/font.css';
import './Pages/css/style.css';
import './Pages/css/mobile.css';
import { Route, Routes, BrowserRouter as Router } from "react-router";

import SessionExpiryCheck from './Pages/SessionExpiryCheck';

import AddGallery from './Pages/Neighbour/AddGallery/AddGallery';
import AddLocalStories from './Pages/Neighbour/AddLocalStories/AddLocalStories';
import BussinessDetails from './Pages/Neighbour/BussinessDetails/BussinessDetails';
import ClippeDeal from './Pages/Neighbour/ClippeDeal/ClippeDeal';
import DealDetails from './Pages/Neighbour/DealDetails/DealDetails';
import EditProfile from './Pages/Neighbour/EditProfile/EditProfile';
import CompleteProfile from './Pages/Neighbour/CompleteProfile/CompleteProfile';
import ForgotPassword from './Pages/Neighbour/ForgotPassword/ForgotPassword';
// import Events from './Pages/Neighbour/Events/Events';
// import EventsDetails from './Pages/Neighbour/EventsDetails/EventsDetails';
import Home from './Pages/Neighbour/Home/Home';
import Deal from './Pages/Neighbour/Deal/Deal';
import Exclusivedeal from './Pages/Neighbour/Exclusivedeal/Exclusivedeal';
import InviteNeighbor from './Pages/Neighbour/InviteNeighbor/InviteNeighbor';
import LocalDashboard from './Pages/Neighbour/LocalDashboard/LocalDashboard';
import LocalDeals from './Pages/Neighbour/LocalDeals/LocalDeals';
import LocalEvent from './Pages/Neighbour/LocalEvent/LocalEvent';
// import LocalHome from './Pages/Neighbour/LocalHome/LocalHome';
import LocalQuestion from './Pages/Neighbour/LocalQuestion/LocalQuestion';
import LocalStories from './Pages/Neighbour/LocalStories/LocalStories';
import Login from './Pages/Neighbour/Login/Login';
import Message from './Pages/Neighbour/Message/Message';
import MyDeals from './Pages/Neighbour/MyDeals/MyDeals';
import NewPassword from './Pages/Neighbour/NewPassword/NewPassword';
import NewPost from './Pages/Neighbour/NewPost/NewPost';
import Notification from './Pages/Neighbour/Notification/Notification';
import OpinionSurvey from './Pages/Neighbour/OpinionSurvey/OpinionSurvey';
import Otp from './Pages/Neighbour/Otp/Otp';

import Settings from './Pages/Neighbour/Settings/Settings';
import Signup from './Pages/Neighbour/Signup/Signup';
import TransactionCompletion from './Pages/Neighbour/TransactionCompletion/TransactionCompletion';
import ViewGallery from './Pages/Neighbour/ViewGallery/ViewGallery';
import ViewProfile from './Pages/Neighbour/ViewProfile/ViewProfile';

import HelpCenter from './Pages/Neighbour/HelpCenter/HelpCenter';
import ContactUs from './Pages/Neighbour/ContactUs/ContactUs';
import Privacy from './Pages/Neighbour/Privacy/Privacy';
import Terms from './Pages/Neighbour/Terms/Terms';

import CustomerSupport from './Pages/Neighbour/CustomerSupport/CustomerSupport';
import Press from './Pages/Neighbour/Press/Press';
import About from './Pages/Neighbour/About/About';
import Howitworks from './Pages/Neighbour/Howitworks/Howitworks';
import Advertisement from './Pages/Neighbour/Advertisement/Advertisement';
import RegisterBusiness from './Pages/Neighbour/RegisterBusiness/RegisterBusiness';
import AffiliatePartnership from './Pages/Neighbour/AffiliatePartnership/AffiliatePartnership';
import Career from './Pages/Neighbour/Career/Career';


import CommonHelpCenter from './Pages/Neighbour/CommonHelpCenter/CommonHelpCenter';
import CommonContactUs from './Pages/Neighbour/CommonContactUs/CommonContactUs';
import CommonPrivacy from './Pages/Neighbour/CommonPrivacy/CommonPrivacy';
import CommonTerms from './Pages/Neighbour/CommonTerms/CommonTerms';
import CommonCustomerSupport from './Pages/Neighbour/CommonCustomerSupport/CommonCustomerSupport';
import CommonPress from './Pages/Neighbour/CommonPress/CommonPress';
import CommonAbout from './Pages/Neighbour/CommonAbout/CommonAbout';

import CommonHowitworks from './Pages/Neighbour/CommonHowitworks/CommonHowitworks';

import CommonAdvertisement from './Pages/Neighbour/CommonAdvertisement/CommonAdvertisement';

import CommonRegisterBusiness from './Pages/Neighbour/CommonRegisterBusiness/CommonRegisterBusiness';

import CommonAffiliatePartnership from './Pages/Neighbour/CommonAffiliatePartnership/CommonAffiliatePartnership';

import CommonCareer from './Pages/Neighbour/CommonCareer/CommonCareer';

import SwitchBusinessProfile from './Pages/Neighbour/SwitchBusinessProfile/SwitchBusinessProfile';

import AddNewBusiness from './Pages/Business/AddNewBusiness/AddNewBusiness';
import AddPromotion from './Pages/Business/AddPromotion/AddPromotion';
import BusinessContactUs from './Pages/Business/BusinessContactUs/BusinessContactUs';
import BusinessForgotPassword from './Pages/Business/BusinessForgotPassword/BusinessForgotPassword';
// import BusinessDashboard from './Pages/Business/BusinessDashboard/BusinessDashboard';
// import BusinessDetails from './Pages/Business/BusinessDetails/BusinessDetails';
// import BusinessHome from './Pages/Business/BusinessHome/BusinessHome';
import BusinessInviteNeighbor from './Pages/Business/BusinessInviteNeighbor/BusinessInviteNeighbor';
import BusinessLogin from './Pages/Business/BusinessLogin/BusinessLogin';
import BusinessMembership from './Pages/Business/BusinessMembership/BusinessMembership';
import BusinessMessage from './Pages/Business/BusinessMessage/BusinessMessage';
import BusinessMyDeal from './Pages/Business/BusinessMyDeal/BusinessMyDeal';
// import BusinessMyPromotions from './Pages/Business/BusinessMyPromotions/BusinessMyPromotions';
import BusinessNewDeal from './Pages/Business/BusinessNewDeal/BusinessNewDeal';
import BusinessNewPassword from './Pages/Business/BusinessNewPassword/BusinessNewPassword';
import BusinessNotification from './Pages/Business/BusinessNotification/BusinessNotification';
import BusinessOrders from './Pages/Business/BusinessOrders/BusinessOrders';
import BusinessOtp from './Pages/Business/BusinessOtp/BusinessOtp';
import BusinessPrivacy from './Pages/Business/BusinessPrivacy/BusinessPrivacy';
import BusinessHelpCenter from './Pages/Business/BusinessHelpCenter/BusinessHelpCenter';

import BusinessCustomerSupport from './Pages/Business/BusinessCustomerSupport/BusinessCustomerSupport';

import BusinessPress from './Pages/Business/BusinessPress/BusinessPress';
import BusinessAbout from './Pages/Business/BusinessAbout/BusinessAbout';
import BusinessHowitworks from './Pages/Business/BusinessHowitworks/BusinessHowitworks';
import BusinessAdvertisement from './Pages/Business/BusinessAdvertisement/BusinessAdvertisement';
import BusinessRegisterBusiness from './Pages/Business/BusinessRegisterBusiness/BusinessRegisterBusiness';
import BusinessAffiliatePartnership from './Pages/Business/BusinessAffiliatePartnership/BusinessAffiliatePartnership';
import BusinessCareer from './Pages/Business/BusinessCareer/BusinessCareer';

import BusinessSignup from './Pages/Business/BusinessSignup/BusinessSignup';
import BusinessTerms from './Pages/Business/BusinessTerms/BusinessTerms';
// import DiscountSale from './Pages/Business/DiscountSale/DiscountSale';
import EditBusiness from './Pages/Business/EditBusiness/EditBusiness';
import CompleteProfileBusiness from './Pages/Business/CompleteProfileBusiness/CompleteProfileBusiness';

import BusinessViewProfile  from './Pages/Business/ViewProfile/ViewProfile';
// import EditDiscountSale from './Pages/Business/EditDiscountSale/EditDiscountSale';
import EditFreeItemSale from './Pages/Business/EditFreeItemSale/EditFreeItemSale';
import EditProductSale from './Pages/Business/EditProductSale/EditProductSale';
import EditStoreSale from './Pages/Business/EditStoreSale/EditStoreSale';          
import FreeItemSale from './Pages/Business/FreeItemSale/FreeItemSale';
import ProductSale from './Pages/Business/ProductSale/ProductSale';
import StoreSale from './Pages/Business/StoreSale/StoreSale';
import SwitchNeighbourProfile from './Pages/Business/SwitchNeighbourProfile/SwitchNeighbourProfile';
import BusinessDealDetail from './Pages/Business/BusinessDealDetail/BusinessDealDetail';


import PrivateLoginRoute from "./Utils/PrivateLoginRoute";
import PrivateRouteNeighbour from "./Utils/PrivateRouteNeighbour";
import PrivateRouteBusiness from "./Utils/PrivateRouteBusiness";
import { ToastContainer } from 'react-toastify';
import FirebaseOTP from './Pages/FirebaseOTP';



function App() {
  return (
    <>
    
    <SessionExpiryCheck />
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="deal" element={<Deal />} />
          <Route exact path="firebaseOTP" element={<FirebaseOTP />} />
          <Route exact path="exclusive-deal" element={<Exclusivedeal />} />
            
          <Route exact path="contact-us" element={<CommonContactUs />} />
          <Route exact path="help-center" element={<CommonHelpCenter />} />
          <Route exact path="privacy" element={<CommonPrivacy />} />
          <Route exact path="terms" element={<CommonTerms />} />

          <Route exact path="customer-support" element={<CommonCustomerSupport />} />

          <Route exact path="press" element={<CommonPress />} />

          <Route exact path="about" element={<CommonAbout />} />

          <Route exact path="how-it-works" element={<CommonHowitworks />} />

          <Route exact path="advertisement" element={<CommonAdvertisement />} />

          <Route exact path="register-business" element={<CommonRegisterBusiness />} />

          <Route exact path="affiliate-partnership" element={<CommonAffiliatePartnership />} />

          <Route exact path="career" element={<CommonCareer />} />

          <Route exact path="neighbour/deal-details/:id" element={<DealDetails />} />

          <Route exact path="neighbour/business-details/:id" element={<BussinessDetails />} />

          <Route exact element={<PrivateLoginRoute />}>
            <Route exact path="neighbour/register" element={<Signup />} />
            <Route exact path="neighbour/login" element={<Login />} />
            <Route exact path="neighbour/forgot-password" element={<ForgotPassword />} />
            <Route exact path="neighbour/otp" element={<Otp />} />
            <Route exact path="neighbour/new-password" element={<NewPassword />} />

            <Route exact path="business/register" element={<BusinessSignup />} />
            <Route exact path="business/login" element={<BusinessLogin />} />
            <Route exact path="business/forgot-password" element={<BusinessForgotPassword />} />
            <Route exact path="business/otp" element={<BusinessOtp />} />
            <Route exact path="business/new-password" element={<BusinessNewPassword />} /> 
          </Route>
          
          <Route exact element={<PrivateRouteNeighbour />}>
            <Route exact path="neighbour/contact-us" element={<ContactUs />} />
            <Route exact path="neighbour/help-center" element={<HelpCenter />} />
            <Route exact path="neighbour/privacy" element={<Privacy />} />
            <Route exact path="neighbour/terms" element={<Terms />} />

            <Route exact path="neighbour/customer-support" element={<CustomerSupport />} />
            <Route exact path="neighbour/press" element={<Press />} />
            <Route exact path="neighbour/about" element={<About />} />
            <Route exact path="neighbour/how-it-works" element={<Howitworks />} />
            <Route exact path="neighbour/advertisement" element={<Advertisement />} />
            <Route exact path="neighbour/register-business" element={<RegisterBusiness />} />
            <Route exact path="neighbour/affiliate-partnership" element={<AffiliatePartnership />} />
            <Route exact path="neighbour/career" element={<Career />} />

            <Route exact path="neighbour/complete-profile" element={<CompleteProfile />} />
            <Route exact path="neighbour/edit-profile" element={<EditProfile />} />
            <Route exact path="neighbour/view-profile" element={<ViewProfile />} />
            <Route exact path="neighbour/home" element={<Home />} />
            <Route exact path="neighbour/add-gallery" element={<AddGallery />} />
            <Route exact path="neighbour/add-local-stories" element={<AddLocalStories />} />
            
            <Route exact path="neighbour/clipped-deal/:id" element={<ClippeDeal />} />          
            
            <Route exact path="neighbour/invite-a-neighbor" element={<InviteNeighbor />} />
            <Route exact path="neighbour/local-dashboard" element={<LocalDashboard />} />
            <Route exact path="neighbour/local-deals" element={<LocalDeals />} />
            <Route exact path="neighbour/local-event" element={<LocalEvent />} />
            <Route exact path="neighbour/local-question" element={<LocalQuestion />} />                            
            <Route exact path="neighbour/local-stories" element={<LocalStories />} />
            <Route exact path="neighbour/message" element={<Message />} />          
            <Route exact path="neighbour/my-deals" element={<MyDeals />} />
            <Route exact path="neighbour/new-post" element={<NewPost />} />
            <Route exact path="neighbour/notification" element={<Notification />} />
            <Route exact path="neighbour/opinion-survey" element={<OpinionSurvey />} />          
            <Route exact path="neighbour/settings" element={<Settings />} />
            <Route exact path="neighbour/transaction-completion/:id" element={<TransactionCompletion />} />
            <Route exact path="neighbour/view-gallery" element={<ViewGallery />} />

            <Route exact path="neighbour/switch-business-profile" element={<SwitchBusinessProfile />} />
          </Route>
          
          <Route exact path="business/contact-us" element={<BusinessContactUs />} />
          <Route exact path="business/privacy" element={<BusinessPrivacy />} />
          <Route exact path="business/terms" element={<BusinessTerms />} />
          <Route exact path="business/help-center" element={<BusinessHelpCenter />} />

          <Route exact path="business/customer-support" element={<BusinessCustomerSupport />} />
          <Route exact path="business/press" element={<BusinessPress />} />
          <Route exact path="business/about" element={<BusinessAbout />} />
          <Route exact path="business/how-it-works" element={<BusinessHowitworks />} />
          <Route exact path="business/advertisement" element={<BusinessAdvertisement />} />
          <Route exact path="business/register-business" element={<BusinessRegisterBusiness />} />
          <Route exact path="business/affiliate-partnership" element={<BusinessAffiliatePartnership />} />
          <Route exact path="business/career" element={<BusinessCareer />} />

          <Route exact element={<PrivateRouteBusiness />}>
            <Route exact path="business/complete-profile" element={<CompleteProfileBusiness />} />
            <Route exact path="business/edit-business" element={<EditBusiness />} />
            <Route exact path="business/view-profile" element={<BusinessViewProfile />} />
            <Route exact path="business/add-new-business" element={<AddNewBusiness />} />
            <Route exact path="business/product-sale" element={<ProductSale />} />
            <Route exact path="business/store-sale" element={<StoreSale />} />
            <Route exact path="business/freeitem-sale" element={<FreeItemSale />} />
            <Route exact path="business/edit-product-sale/:id" element={<EditProductSale />} />
            <Route exact path="business/edit-freeitem-sale/:id" element={<EditFreeItemSale />} />

            <Route exact path="business/my-deal" element={<BusinessMyDeal />} />
            
            <Route exact path="business/add-promotion" element={<AddPromotion />} />
            <Route exact path="business/invite-a-neighbor" element={<BusinessInviteNeighbor />} />
            <Route exact path="business/membership" element={<BusinessMembership />} />
            <Route exact path="business/message" element={<BusinessMessage />} />
            <Route exact path="business/new-deal" element={<BusinessNewDeal />} />
            <Route exact path="business/notification" element={<BusinessNotification />} />
            <Route exact path="business/orders" element={<BusinessOrders />} />
            <Route exact path="business/edit-store-sale/:id" element={<EditStoreSale />} /> 

            <Route exact path="business/switch-neighbour-profile" element={<SwitchNeighbourProfile />} />

            <Route exact path="business/business-deal-details/:id" element={<BusinessDealDetail />} />

          </Route>

          {/* <Route exact path="neighbour/events" element={<Events />} /> */}
          {/* <Route exact path="neighbour/events-details" element={<EventsDetails />} /> */}
          {/* <Route exact path="neighbour/local-home" element={<LocalHome />} /> */}
          {/* <Route exact path="business/dashboard" element={<BusinessDashboard />} /> */}
          {/* <Route exact path="business/business-details" element={<BusinessDetails />} /> */}
          {/* <Route exact path="business/" element={<BusinessHome />} /> */}
          {/* <Route exact path="business/my-promotions" element={<BusinessMyPromotions />} /> */}
          {/* <Route exact path="business/discount-sale" element={<DiscountSale />} /> */}
          {/* <Route exact path="business/edit-discount-sale" element={<EditDiscountSale />} /> */}
        </Routes>
      </Router>   
      <ToastContainer />              
    </>
  );
}

export default App;